<div class="full-width-image-container">
  <img src="../../assets/AdobeStock_3558442.jpeg" alt="Header Image">
</div>

<div class="top">
  <div>Do The <span>Right Thing</span></div>
  <div>On Point <span>With Safety</span></div>
  <div>Roll up <span>Your Sleeves</span></div>
</div>
<hr class="hr">
<br><br><br>
<div class="dev-msg">
    <div class="links-title">Forecast by Office</div>
</div>
<br>

<div class="container">
    <div class="row">
      <div class="col-6">
        <a class="weatherwidget-io" href="https://forecast7.com/en/32d76n97d33/fort-worth/?unit=us" data-label_1="Fort Worth, TX" data-label_2="WEATHER" data-icons="Climacons Animated" data-days="7" data-theme="weather_one">Fort Worth, TX WEATHER</a>
      </div>
      <div class="col-6">
        <a class="weatherwidget-io" href="https://forecast7.com/en/29d76n95d37/houston/?unit=us" data-label_1="Houston, TX" data-label_2="WEATHER" data-icons="Climacons Animated" data-days="7" data-theme="weather_one">Houston, TX WEATHER</a>
      </div>
    </div>

    <div class="row">
        <div class="col-6">
          <a class="weatherwidget-io" href="https://forecast7.com/en/32d81n96d95/irving/?unit=us" data-label_1="Irving, TX" data-label_2="WEATHER" data-icons="Climacons Animated" data-days="7" data-theme="weather_one">Irving, TX WEATHER</a>
        </div>
        <div class="col-6">
          <a class="weatherwidget-io" href="https://forecast7.com/en/33d15n96d82/frisco/?unit=us" data-label_1="Frisco, TX" data-label_2="WEATHER" data-icons="Climacons Animated" data-days="7" data-theme="weather_one">Frisco, TX WEATHER</a>
        </div>
    </div>

    <div class="row">
        <div class="col-6">
          <a class="weatherwidget-io" href="https://forecast7.com/en/32d00n102d08/midland/?unit=us" data-label_1="Midland, TX" data-label_2="WEATHER" data-icons="Climacons Animated" data-days="7" data-theme="weather_one">Midland, TX WEATHER</a>
        </div>
        <div class="col-6">
          <a class="weatherwidget-io" href="https://forecast7.com/en/30d27n97d74/austin/?unit=us" data-label_1="Austin, TX" data-label_2="WEATHER" data-icons="Climacons Animated" data-days="7" data-theme="weather_one">Austin, TX WEATHER</a>
        </div>
      </div>

    <div class="row">
        <div class="col-6">
          <a class="weatherwidget-io" href="https://forecast7.com/en/32d52n93d73/bossier-city/?unit=us" data-label_1="Bossier City, LA" data-label_2="WEATHER" data-icons="Climacons Animated" data-days="7" data-theme="weather_one">Bossier City, LA WEATHER</a>
        </div>
        <div class="col-6">
          <a class="weatherwidget-io" href="https://forecast7.com/en/33d45n112d07/phoenix/?unit=us" data-label_1="Phoenix, AZ" data-label_2="WEATHER" data-icons="Climacons Animated" data-days="7" data-theme="weather_one">Phoenix, AZ WEATHER</a>
        </div>
    </div>

    <div class="row">
        <div class="col-6">
          <a class="weatherwidget-io" href="https://forecast7.com/en/33d27n93d24/magnolia/?unit=us" data-label_1="Magnolia, AR" data-label_2="WEATHER" data-icons="Climacons Animated" data-days="7" data-theme="weather_one">Magnolia, AR WEATHER</a>
        </div>
        <div class="col-6">
          <a class="weatherwidget-io" href="https://forecast7.com/en/40d48n104d90/windsor/?unit=us" data-label_1="Windsor, CO" data-label_2="WEATHER" data-icons="Climacons Animated" data-days="7" data-theme="weather_one">Windsor, CO WEATHER</a>
        </div>
    </div>
    <br><br><br>

    <div class="iframe-container-weather">
        <iframe width="900" height="800" src="https://embed.windy.com/embed2.html?lat=37.510&lon=-100.107&detailLat=37.562&detailLon=-97.383&width=650&height=450&zoom=4&level=surface&overlay=radar&product=radar&menu=&message=&marker=&calendar=24&pressure=&type=map&location=coordinates&detail=&metricWind=default&metricTemp=default&radarRange=-1" frameborder="0"></iframe>
    </div>




